var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73872 4.10156L3.12924 10.5222C3.09599 10.5546 3.07198 10.5955 3.06054 10.6395L2.32794 13.4958C2.30603 13.5817 2.33204 13.6732 2.39664 13.7359C2.44552 13.7834 2.51212 13.8097 2.58024 13.8097C2.60111 13.8097 2.62245 13.8072 2.64322 13.8021L5.58371 13.0904C5.62954 13.0793 5.67118 13.0561 5.70443 13.0238L12.3145 6.60356L9.73872 4.10156Z",
    fill: "#2468FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.952 3.22508L13.2163 2.51041C12.7245 2.03276 11.8675 2.03322 11.3763 2.51041L10.4751 3.38584L13.0508 5.88774L13.952 5.01231C14.1976 4.77381 14.3329 4.45636 14.3329 4.11874C14.3329 3.78112 14.1976 3.46367 13.952 3.22508Z",
    fill: "#2468FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.20bb8f44.svg";
export { ForwardRef as ReactComponent };